const clerkDebtorRoutes = {
  path: "/employee",
  component: () => import("@/layouts/AuthorizedEmployeeLayout.vue"),
  children: [
    {
      path: "dashboard",
      name: "private-dashboard",
      component: () => import("../views/employee/PrivateDashboard.vue"),
    },
    {
      path: "my-cases",
      name: "my-cases",
      component: () => import("../views/employee/MyCases.vue"),
    },
    {
      path: "add-case",
      name: "add-case",
      component: () => import("../views/employee/AddCase.vue"),
    },
    {
      path: "edit-case/:id",
      name: "edit-case",
      meta: {
        cache: true,
      },
      component: () => import("../views/employee/EditCase.vue"),
    },
    {
      path: "edit-case-employee/:id",
      name: "edit-case-employee",
      meta: {
        cache: true,
      },
      component: () => import("../views/employee/EditCaseEmployee.vue"),
    },
    {
      path: "add-case-date/:id",
      name: "add-case-date",
      meta: {
        cache: true,
      },
      component: () => import("../views/employee/AddCaseDate.vue"),
    },
    {
      path: "case/:id",
      name: "view-case",
      meta: {
        cache: true,
      },
      component: () => import("../views/employee/ViewCase.vue"),
    },
    {
      path: "case/:id/wvp-case",
      name: "view-wvp-case",
      component: () => import("../views/employee/ViewWvpCase.vue"),
    },
    {
      path: "manage-banks",
      name: "manage-banks",
      component: () => import("../views/employee/Banks.vue"),
    },
    {
      path: "manage-banks/add",
      name: "add-bank",
      component: () => import("../views/employee/AddBank.vue"),
    },
    {
      path: "manage-banks/edit/:id",
      name: "edit-bank",
      component: () => import("../views/employee/EditBank.vue"),
    },
  ],
  meta: {
    requiresAuth: true,
    impersonation: false,
    role: "clerk",
  },
};

const clerkCorporateRoutes = {
  path: "/employee/corporate",
  component: () => import("@/layouts/AuthorizedEmployeeLayout.vue"),
  children: [
    {
      path: "dashboard",
      name: "corporate-dashboard",
      component: () => import("../views/employee/CorporateDashboard.vue"),
    },
    {
      path: "add-case",
      name: "corporate-add-case",
      component: () => import("../views/employee/AddCorporateCase.vue"),
    },
    {
      path: "case/:id/edit",
      name: "corporate-edit-case",
      meta: {
        cache: true,
      },
      component: () => import("../views/employee/EditCorporateCase.vue"),
    },
    {
      path: "case/:id/edit-employee",
      name: "corporate-edit-case-employee",
      meta: {
        cache: true,
      },
      component: () =>
        import("../views/employee/EditCorporateCaseEmployee.vue"),
    },
    {
      path: "case/:id",
      name: "corporate-view-case",
      meta: {
        cache: true,
      },
      component: () => import("../views/employee/ViewCorporateCase.vue"),
    },
    {
      path: "case/:id/email-overview",
      name: "email-overview",
      meta: {
        cache: true,
      },
      component: () => import("@/views/employee/EmailOverview.vue"),
    },
  ],
  meta: {
    requiresAuth: true,
    impersonation: false,
    role: "clerk",
  },
};

const clerkDebtorEditRoutes = {
  path: "/employee/debtor-view/edit-case/:id",
  name: "debtor-view-edit-case",
  component: () => import("@/layouts/AuthorizedEmployeeLayoutDebtorView.vue"),
  meta: {
    requiresAuth: true,
    impersonation: true,
    role: "clerk",
  },
  children: [
    {
      path: "home",
      name: "clerk-debtor-view-home",
      component: () => import("@/views/HomeView.vue"),
      meta: {
        previous: null,
        next: "clerk-debtor-view-generalData",
        order: 0,
      },
    },
    {
      path: "general-data",
      name: "clerk-debtor-view-generalData",
      component: () => import("@/views/GeneralData.vue"),
      meta: {
        previous: "clerk-debtor-view-home",
        next: "clerk-debtor-view-maritalData",
        order: 1,
      },
    },
    {
      path: "marital-data",
      name: "clerk-debtor-view-maritalData",
      component: () => import("@/views/MaritalData.vue"),
      meta: {
        previous: "clerk-debtor-view-generalData",
        next: "clerk-debtor-view-jobData",
        order: 2,
      },
    },
    {
      path: "job-data",
      name: "clerk-debtor-view-jobData",
      component: () => import("@/views/JobData.vue"),
      meta: {
        previous: "clerk-debtor-view-maritalData",
        next: "clerk-debtor-view-selfemploymentData",
        order: 3,
      },
    },
    {
      path: "selfemployment-data",
      name: "clerk-debtor-view-selfemploymentData",
      component: () => import("@/views/SelfemploymentData.vue"),
      meta: {
        previous: "clerk-debtor-view-jobData",
        next: "clerk-debtor-view-incomeData",
        order: 4,
      },
    },
    {
      path: "income-data",
      name: "clerk-debtor-view-incomeData",
      component: () => import("@/views/IncomeData.vue"),
      meta: {
        previous: "clerk-debtor-view-selfemploymentData",
        next: "clerk-debtor-view-assetData",
        order: 5,
      },
    },
    {
      path: "asset-data",
      name: "clerk-debtor-view-assetData",
      component: () => import("@/views/AssetData.vue"),
      meta: {
        previous: "clerk-debtor-view-incomeData",
        next: "clerk-debtor-view-taxData",
        order: 6,
      },
    },
    {
      path: "tax-data",
      name: "clerk-debtor-view-taxData",
      component: () => import("@/views/TaxData.vue"),
      meta: {
        previous: "clerk-debtor-view-assetData",
        next: "clerk-debtor-view-insolvencyChallenge",
        order: 7,
      },
    },
    {
      path: "insolvency-challenge",
      name: "clerk-debtor-view-insolvencyChallenge",
      component: () => import("@/views/InsolvencyChallenge.vue"),
      meta: {
        previous: "clerk-debtor-view-taxData",
        next: "clerk-debtor-view-requiredUploads",
        order: 8,
      },
    },
    {
      path: "required-uploads",
      name: "clerk-debtor-view-requiredUploads",
      component: () => import("@/views/RequiredUploads.vue"),
      meta: {
        previous: "clerk-debtor-view-insolvencyChallenge",
        next: "clerk-debtor-view-overview",
        order: 9,
      },
    },
    {
      path: "overview",
      name: "clerk-debtor-view-overview",
      component: () => import("@/views/OverView.vue"),
      meta: {
        previous: "clerk-debtor-view-requiredUploads",
        next: null,
        order: 10,
      },
    },
  ],
};

export { clerkDebtorRoutes, clerkCorporateRoutes, clerkDebtorEditRoutes };
